import React from 'react';
import PropTypes from 'prop-types';

import CollapsableRow from './collapsable_row';
import Deal from './deal';

export default function Deals({ deals, orderedColumns }) {
  const dealsGroupedByParent = {};
  const parentDeals = [];

  deals.forEach((deal) => {
    if (deal.parentDealId) {
      if (!dealsGroupedByParent[deal.parentDealId]) {
        dealsGroupedByParent[deal.parentDealId] = [];
      }

      dealsGroupedByParent[deal.parentDealId].push(deal);
    } else {
      parentDeals.push(deal);
    }
  });

  return (parentDeals.length > 0 ? parentDeals : deals).map(deal => (
    <React.Fragment key={deal.id}>
      {!deal.parent && <Deal deal={deal} orderedColumns={orderedColumns} />}
      <CollapsableRow deals={dealsGroupedByParent[deal.id]} orderedColumns={orderedColumns}/>
    </React.Fragment>
  ));
}

Deals.propTypes = {
  deals: PropTypes.arrayOf(PropTypes.object).isRequired,
  orderedColumns: PropTypes.array.isRequired,
};
